export const parseCategory = category => ({
  id: category.id,
  name: category.attributes.name,
  slug: category.attributes.slug,
  templateCount: category.attributes.templateCount,
  parentCategoryId: category.attributes.categoryId,
  metaTitle: category.attributes.metaTitle,
  metaDescription: category.attributes.metaDescription
})

export const parseArticleCategory = c => ({
  id: c.id,
  title: c.attributes.title,
  slug: c.attributes.slug,
  metaTitle: c.attributes.metaTitle,
  metaDescription: c.attributes.metaDescription
})
